import React from "react";
import { injectIntl } from "react-intl";
import Breadcrumb from "../../common/Breadcrumb";
import ButtonBack from "../../common/ButtonBack";
import Propertii from "../../common/Propertii";
import CreditReportingSubscriptionsReport from "../../common/ReportCreditReportingSubscriptions";

class CreditReportingSubscriptions extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company transaction report component.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/manager/reports" parentPage="Reports" childPage="Credit Reporting Subscriptions" />

                    <CreditReportingSubscriptionsReport companyId={this.props.userSession.sessionRole.companyId} userType='TYPE_MANAGER'/>

                    <div className="row">
                        <div className="col text-right">
                            <ButtonBack path="/manager/reports" />
                        </div>
                    </div>

                </div>

            </div>
        )
    };
}

export default injectIntl(CreditReportingSubscriptions);